import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextField } from '@fs/zion-ui'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../hooks/useNotifications'
import { tombstonePerson } from '../../services/personService'
import { PersonContext } from '../person/PersonContext'

export default function TombstonePersonDialogOverlay({ ...overlay }) {
  const { isOpen, transitioning } = overlay
  const { currentPerson, fetchCurrentPerson } = useContext(PersonContext)
  const [reason, setReason] = useState()
  const { t } = useTranslation()
  const { error } = useNotifications()
  const focusElementRef = useRef()

  const confirmBtnOnClick = async () => {
    try {
      overlay.close()
      await tombstonePerson(currentPerson.id, reason)
      fetchCurrentPerson()
    } catch (err) {
      error(
        t('metadata.errors.tombstoningPerson', {
          defaultValue: `Error tombstoning person: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  useEffect(() => {
    if (!isOpen && transitioning) {
      // The overlay is currently exiting (still transitioning out)
      setReason()
    }
  }, [isOpen, transitioning])

  return (
    <DialogOverlay
      focusRef={focusElementRef}
      {...overlay}
      title={t('person.summary.tombstonePersonDialog.heading', 'Tombstone Person')}
      subtitle={t(
        'person.summary.tombstonePersonDialog.subheading',
        'Are you sure you want to tombstone this person?',
        {
          personId: currentPerson.id,
        }
      )}
    >
      <TextField
        ref={focusElementRef}
        role="textbox"
        id="livingChangeMessage"
        label={t('reason', 'Reason')}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={confirmBtnOnClick}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
